import {
  CButton,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CInput,
  CLabel,
  CRow,
} from "@coreui/react";
import React, { useEffect, useState } from "react";
import { apiCall } from "src/_apiConfig/apiCall";
import { useHistory } from "react-router-dom";
import Auth from "src/auth";
const UpdatePaymentSuccessDate = () => {
  const { authenticated } = Auth();
  const history = useHistory();
  // eslint-disable-next-line no-unused-vars
  const [loading, setloading] = useState(false);
  const [StartDate, setStartDate] = useState();

  useEffect(() => {}, []);

  const postTenderData = async (e) => {
    e.preventDefault();
    setloading(true);
    const header = new Headers();
    //header.append("Content-Type", "application/json");
    const response = await apiCall(
      `PaymentResponse/UpdatePaymentSuccessDate?strtdate=${StartDate}`,
      "GET",
      header,
      null
    );
    await response.json();

    if (response.status === 200) {
      setloading(false);

      history.push(
        authenticated.role === "CGMF" ? "/tender/tenderlist" : "/tenderlist"
      );
      // alert('RECORD UPDATED SUCCESSFULLY');
    }
  };

  return (
    <>
      <CCardHeader className="mb-3">
        <CRow xl={12} className="pt-3 ">
          <CCol xl={10}>
            <h3> Update Payment Success Date </h3>
          </CCol>
        </CRow>
      </CCardHeader>
      <CCardBody>
        <CForm onSubmit={postTenderData}>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
                Start Date
              </CLabel>
            </CCol>
            <CCol xl={4}>
              <CInput
                type="date"
                placeholder=""
                value={StartDate == null ? "" : StartDate}
                onChange={(e) => {
                  setStartDate(e.target.value);
                }}
              />
            </CCol>
            <CCol xl={2}>
              <CButton className="ml-3" color="success" type="submit">
                Update
              </CButton>
            </CCol>
          </CRow>{" "}
        </CForm>
      </CCardBody>
    </>
  );
};
export default UpdatePaymentSuccessDate;
